import Vue from 'vue'
import Router from 'vue-router'
import Merchant from './modules/merchant/index.js'
import Integration from '@/pages/general/Integration.vue'
import BeDirectBookingGoogle from '@/pages/hotel/be/BeDirectBookingGoogle'
import CommunityIndex from '@/pages/community/'
import CommunityHome from '@/pages/community/Home'
import DevelopmentOnly from '@/pages/general/DevelopmentOnly'
import ClearDataLocal from '@/pages/general/ClearData'
const emptyView = {template: '<router-view></router-view>'}

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/google-direct-booking',
      name: 'BeDirectBookingGoogle',
      component: BeDirectBookingGoogle,
      meta:{
        module_type: 'merchant-hotel-booking_engine',
        no_wrapper: true
      }
    },
    {
      path: '/integration',
      name: 'Integration',
      component: Integration
    },
    {
      path: '/community',
      component:CommunityIndex,
      children: [
        {
          path: '/:community_code/group',
          name: 'CommunityHome',
          component: CommunityHome,
          meta:{
            module_type: 'community',
            no_wrapper: true
          }
        },
      ]
    },
    {
      path: "/development",
      name: "DevelopmentOnly",
      component: DevelopmentOnly
    },
    {
      path: "/clear-data-guestaps-01",
      name: "ClearDataLocal",
      component: ClearDataLocal
    },
    ...Merchant
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js